module.exports = __webpack_public_path__ + "static/media/photo.12af99b1.svg";